import {Component, Input} from '@angular/core';
import {InternalImpactPointService} from '@shared/components/internal-impact-point/internal-impact-point.service';
import {ImpactPointTypes} from '@shared/enums/impact-point-types.enum';

@Component({
    selector: 'amd-internal-impact-point-seat',
    templateUrl: './internal-impact-point-seat.component.html',
    styleUrls: ['./internal-impact-point-seat.component.scss']
})
export class InternalImpactPointSeatComponent {

    @Input() seat: ImpactPointTypes;

    get isActive(): boolean {
        return this.internalImpactPointService.isActive(this.seat);
    }

    get canEdit(): boolean {
        return this.internalImpactPointService.canEdit;
    }

    constructor(private internalImpactPointService: InternalImpactPointService) {
    }

    onSeatClick(seat: ImpactPointTypes): void {
        this.internalImpactPointService.onSeatClick(seat);
    }

}
